<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_catchWord') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_view') }}
            span(slot="value") {{ $i18n.tc('trainer.trainer_gameFormSetting_' + parameters.viewType, 1) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.mode) }}
        game-preview-setting
            span(slot="name") {{ groupsString }}
            span(slot="value") {{ parameters.selectedGroups.join('; ') }}
        game-preview-setting(v-for="(group, index) in lettersForGroups" :key="index")
            span(slot="name") {{ group.name }}
            span(slot="value") {{ group.letters.join('; ') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}
            span(slot="value") {{ parameters.showTime }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        template(v-if="parameters.isSeries && parameters.mode === 'interactive'")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_showInSeries', {element: $i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.viewType)}) }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfSeries') }}
                span(slot="value") {{ parameters.seriesAmount }}
        game-preview-setting
            span(slot="name") {{ amountOfItemsString }}
            span(slot="value") {{ parameters.amountOfWords }}
        game-preview-setting(v-if="parameters.mode === 'static'")
            span(slot="name") {{ $i18n.t('olympiads.olympiads_olympiadForm_timeForAnswer') }}
            span(slot="value") {{ parameters.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        game-preview-setting(v-if="parameters.wordsMovement")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_movement', {element: $i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.viewType)}) }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
        game-preview-setting
            span(slot="name") {{ invertedString }}
            span(slot="value")
                template(v-if="parameters.invertedWords") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                template(v-else) {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
        game-preview-setting(v-if="parameters.viewType === 'words'")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_accentedWords') }}
            span(slot="value")
                template(v-if="parameters.accentedWords") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                template(v-else) {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            amountOfItemsString () {
                switch (this.parameters.viewType) {
                    case ('words'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWords');
                    case('syllables'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_amountOfSyllables');
                    case ('letters'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_amountOfLetters');
                }
            },
            invertedString () {
                switch (this.parameters.viewType) {
                    case ('words'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_invertedWords');
                    case('syllables'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_invertedSyllables');
                    case ('letters'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_invertedLetters');
                }
            },
            groupsString () {
                return this.parameters.viewType !== 'letters'
                        ? this.$i18n.t('trainer.trainer_gameFormSetting_groups')
                        : this.$i18n.tc('trainer.trainer_gameFormSetting_letters', 1)
            },
            lettersForGroups() {
                let newArray = [];
                let groupsWithLettersSetting = ['Группа 1 (ма, ро)', 'Группа 2 (мя, ки)', 'Группа 3 (ам, ор)', 'Группа 4 (ям, ер)'];
                groupsWithLettersSetting.forEach(key => {
                    if (this.parameters[key] && this.parameters.selectedGroups.find(item => item.includes(key))) {
                        newArray.push({
                            name: key,
                            letters: this.parameters[key],
                        });
                    }
                });
                this.parameters.lettersForGroups = newArray;
                return newArray;
            }
        }
    }
</script>
